import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@material-ui/core';

import { BasicInput, Typography } from '@dev/ee-components';
import { debounce } from '@/services/tools/debounce';
import { PaidNewsletterDeleteModalProps } from '@/components/PaidNewsletters/PaidNewslettersInterface';


export const PaidNewsletterDeleteModalBody = (props: PaidNewsletterDeleteModalProps): JSX.Element => {
    const { t } = useTranslation();
    const { checkedPaidNewsletters, deleteConfirmationText, changeDeleteConfirmationText } = props;
    const checkedPaidNewslettersLength = checkedPaidNewsletters?.length || 0;
    const name = checkedPaidNewslettersLength ? checkedPaidNewsletters[0] : '';

    const handleDeleteConfirmationTextChange = (e) => {
        debounce(() => changeDeleteConfirmationText(e?.target?.value))
    }

    return (
        <>
            <Typography variant='body1'>{checkedPaidNewslettersLength > 1 ? t('deletedraft_more_desc') : t('deletedraft_one_desc', {name})}</Typography>
            <Box mt="16px" mb="8px">
                <Typography variant='body1'>{t('paidnewsletterdelete_confirmation')}</Typography>
            </Box>
            <BasicInput 
                id="input-delete-confirmation"
                defaultValue={deleteConfirmationText}
                onChange={handleDeleteConfirmationTextChange}
            />
        </>
    );
};
